import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { INVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS } from './redirect-funds.constants';

@Component({
  selector: 'app-redirect-funds',
  templateUrl: './redirect-funds.component.html',
  styleUrl: './redirect-funds.component.scss'
})
export class RedirectFundsComponent implements OnInit, OnDestroy {

    @Input() currentFunds: IPolicyAsset[] = [];
    @Input() policyFunds: IPolicyAsset[] = [];
    @Input() form: FormGroup;
    @Input() isReadOnly: boolean;
    tableKeys: ITableKey[] = []
    destroy$ = new Subject();

    ngOnInit(): void {
        this.tableKeys = INVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS;
        this.manageAllocationValues();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    manageAllocationValues() {
        this.form.get('TFRAllocation')?.setValue(this.currentFunds.reduce((acc, fund) => {
        return acc + (fund.TFRAllocation ? parseFloat(fund.TFRAllocation) : 0);
        }, 0));

        this.form.get('companyAllocation')?.setValue(this.currentFunds.reduce((acc, fund) => {
            return acc + (fund.companyAllocation ? parseFloat(fund.companyAllocation) : 0);
        }, 0));

        this.form.get('subscriberAllocation')?.setValue(this.currentFunds.reduce((acc, fund) => {
            return acc + (fund.subscriberAllocation ? parseFloat(fund.subscriberAllocation) : 0);
        }, 0));
    }

}
